import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { streamSse } from "@/lib/upload";

export function useAiCopy(contest, setGame, setRulesDraft) {
  const [ai, setAi] = useState({ task: "description", model: "gpt", extra: "", out: "", busy: false });

  const stream = async (task, onChunk) => {
    setAi((a) => ({ ...a, task, busy: true, out: "" }));
    try {
      await streamSse(api.aiCopyUrl(contest.id), { task, model: ai.model, extra: ai.extra }, onChunk);
      return true;
    } catch (e) {
      toast.error(e.message);
      return false;
    } finally {
      setAi((a) => ({ ...a, busy: false }));
    }
  };

  const runAi = () => stream(ai.task, (t) => setAi((a) => ({ ...a, out: a.out + t })));

  const generateRules = async () => {
    let out = "";
    const ok = await stream("rules", (t) => { out += t; setRulesDraft(out); setAi((a) => ({ ...a, out })); });
    if (ok) toast.success("Regolamento generato: controlla e salva");
  };

  const applyAi = () => {
    if (ai.task === "screens") {
      try {
        setGame((g) => ({ ...g, ...JSON.parse(ai.out.replace(/```json|```/g, "").trim()) }));
        toast.success("Testi videate applicati: ricorda di salvare");
      } catch {
        toast.error("Risposta non in formato JSON valido");
      }
      return;
    }
    if (ai.task === "rules") {
      setRulesDraft(ai.out.trim());
      toast.success("Regolamento inserito nel campo: ricorda di salvare");
      document.querySelector('[data-testid="rules-card"]')?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    navigator.clipboard.writeText(ai.out);
    toast.success("Testo copiato negli appunti");
  };

  return { ai, setAi, runAi, applyAi, generateRules };
}
